var hd = document.getElementsByTagName('head')[0];
var jq = document.createElement('script');
jq.setAttribute('type', 'text/javascript');
jq.setAttribute('src', 'https://code.jquery.com/jquery-3.6.3.min.js');
hd.appendChild(jq);

jq.onload = function() {
  jQuery(document).ready(function(){
    //get cookie
    function getCookie(c_name) {
      var i,x,y,ARRcookies=document.cookie.split(";");
      for (i=0;i<ARRcookies.length;i++) {
        x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
        y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
        x=x.replace(/^\s+|\s+$/g,"");
        if (x==c_name) {
          return unescape(y);
        }
      }
    }
    if(typeof getCookie("discount_code") != "undefined") {
      var dis_per = 0;
      if(getCookie("discount_code") == "NPNWCQ6BVMT7") {
        dis_per = 10;
      }
      if(getCookie("discount_code") == "C1NEAS67TYMP") {
        dis_per = 15;
      }
      if(getCookie("discount_code") == "D8GEF81FRACY") {
        dis_per = 20;
      }
      //category page
      if(jQuery('div[class="price price--top"]').length && dis_per > 0) {
        jQuery('div[class="price price--top"]').each(function(){
          jQuery(this).addClass('price--on-sale');
          var tmp_price = jQuery(this).find('span[class="shirtee_price"]').html();
          var tmp_discount = (eval(tmp_price / 100) * dis_per / 100);
          var sale_price = eval(tmp_price / 100) - tmp_discount;
          jQuery(this).find('s[class="price__was"]').html(jQuery(this).find('strong[class="price__current"]').html());
          var shirtee_tmp_price = jQuery(this).find('span[class="shirtee_tmp_price"]').html().replace("0,00", sale_price.toFixed(2));
          jQuery(this).find('strong[class="price__current"]').html(shirtee_tmp_price);
        });
      }
      //product page
      if(jQuery('div[class="product-info__price"]').length && dis_per > 0) {
        jQuery('div[class="product-info__price"]').find('div[class="price"]').each(function(){
          jQuery(this).addClass('price--on-sale');
          var tmp_price = jQuery(this).find('span[class="shirtee_price"]').html();
          var tmp_discount = (eval(tmp_price / 100) * dis_per / 100);
          var sale_price = eval(tmp_price / 100) - tmp_discount;
          jQuery(this).find('s[class="price__was"]').html(jQuery(this).find('strong[class="price__current"]').html());
          var shirtee_tmp_price = jQuery(this).find('span[class="shirtee_tmp_price"]').html().replace("0,00", sale_price.toFixed(2));
          jQuery(this).find('strong[class="price__current"]').html(shirtee_tmp_price);
        });
      }
    }

    //possible that hide variations which are not avaialble in the dropdown then? planet bundle app
    setTimeout(function () {
      if(jQuery('div[class="planet-bundle-widget"]').length) {
        var vid = ["49300537147719","49300537180487","49300537803079","49300537901383","49300538032455","49300538097991","49300538130759","49300538163527","49300538229063","49300538294599","49418276962631","49418277060935","49418277192007","49418277257543","49418277290311","49418277323079","49418277355847","49418277388615","49418231447879","49418231546183","49418231677255","49418231742791","49418231775559","49418231808327","49418231841095","49418231873863","49418277585223","49418277683527","49418277814599","49418277880135","49418277912903","49418277945671","49418277978439","49418278011207"];
        for(i=0; i < vid.length; i++) {
          jQuery('option[value="'+vid[i]+'"]').attr("disabled", "disabled");
        }
      }
    }, 10000);
    //end
  });  
}